import { useState } from "react";
import styles from './apppay.module.css';
import Helmet from "react-helmet";
import { Parallax, Background } from 'react-parallax';
import { ChevronLeft } from "react-feather";
import { Link as Linkto } from "react-router-dom";
import Page404 from "../../auth/Page404";
import Loader from "../../../components/Loader";
import axios from 'axios';
import { useEffect } from "react";
import { SmartToaster, toast } from "react-smart-toaster";
import dayjs from "dayjs";
import { useRef } from "react";
import Step2 from "./components/Step2";
import Step1 from "./components/Step1";

const AppPay = ({ history, match }) => {
    const { token } = match.params;
    const [loading, setLoading] = useState(true);
    const [isNotExist, setIsNotExist] = useState(false);
    const [propertyDet, setPropertyDet] = useState({});
    const [tenantDet, setTenantDet] = useState({});
    const [tenantDet2, setTenantDet2] = useState(null);
    const [isSecondPaymentStep, setIsSecondPaymentStep] = useState(false);
    const [paymentData, setPaymentData] = useState(null);
    const [connectedAccounts, setConnectedAccounts] = useState([]);
    const mainDivRef = useRef(null);

    useEffect(() => {
        axios.get(process.env.REACT_APP_PAYMENT_API_URL + 'v1/check-tenant-payment-token/' + token).then(response => {
            let resData = response.data.data;
            setLoading(false);
            if (resData.property_id) {
                getPropertyInfo(resData.property_id);
            }

            if (resData.tenant_id) {
                getTenantInfo(resData.tenant_id);
            }

            if (resData.tenant_info_id) {
                getTenantInfoDet(resData.tenant_info_id);
            }

            if (resData.is_exist === 0) {
                setIsNotExist(true);
            }
        }).catch(error => {
            setLoading(false);
        });

        const getTenantInfo = async (id) => {
            await axios.get(process.env.REACT_APP_PAYMENT_API_URL + 'v1/tenant-payment-info/' + id).then(response => {
                let resData = response.data.data;
                setTenantDet(resData);
            });
        }

        const getTenantInfoDet = async (id) => {
            await axios.get(process.env.REACT_APP_PAYMENT_API_URL + 'v1/tenant-payment-info-det/' + id).then(response => {
                let resData = response.data.data;
                setTenantDet2(resData);
            });
        }
    }, [token]);

    const getPropertyInfo = async (id) => {
        await axios.get(process.env.REACT_APP_APPLICANT_API_URL + 'v1/application/property-det/' + id).then(response => {
            const resData = response.data.propertyDet;
            setPropertyDet(resData);
        })
    }

    useEffect(() => {
        if (tenantDet2?.id) {
            axios.get(process.env.REACT_APP_PAYMENT_API_URL + 'v1/connected-accounts/' + tenantDet2?.id).then(response => {
                setConnectedAccounts(response.data.data);
            })
        }
    }, [tenantDet2]);

    useEffect(() => {
        if (mainDivRef.current) {
            mainDivRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
    }, [isSecondPaymentStep]);

    return (<>
        {loading && <Loader />}
        {isNotExist && <Page404 />}

        {(!isNotExist) && <>
            <Helmet title="Payment" />

            <Parallax strength={300} className="RentalParallax">
                <Background className="custom-bg">
                    <img src="/static/img/rental-app-bg.jpg" alt="fill murray" />
                </Background>
            </Parallax>

            <div className="WhiteBG">
                <div className={`${styles.RentalAppliArea}`} ref={mainDivRef}>
                    {isSecondPaymentStep && paymentData && <button className={`${styles.BackBUStep2}`} onClick={(e) => setIsSecondPaymentStep(false)}><ChevronLeft /> Back</button>}
                    <div className={`${styles.RentalAppliHead}`}>
                        {(tenantDet?.theme_options?.image_url !== '') && <img src={tenantDet?.theme_options?.image_url} alt="logo" />}
                        {(tenantDet?.theme_options?.image_url === '') && <img src={'/static/img/logo.svg'} alt="logo" />}
                        <p className={`${styles.RentalAppliHeadTitle}`}>{propertyDet?.name}</p>
                        <p className={`${styles.RentalAppliHeadTitle}`}>Rent Payment</p>
                    </div>

                    <div className={`${styles.ApplicantSec}`} ref={mainDivRef}>
                        <p className={`${styles.ApplicantSecTitle}`}>{tenantDet?.balancestr}</p>
                        <p className={`${styles.ApplicantSecSubTitle}`}>{(tenantDet?.balance2 < 0) ? 'Over Paid' : 'Balance Due'}</p>


                        {!isSecondPaymentStep && <Step1 tenantDet={tenantDet} tenantDet2={tenantDet2} setPaymentData={setPaymentData.bind(this)} setIsSecondPaymentStep={setIsSecondPaymentStep.bind(this)} />}

                        {isSecondPaymentStep && paymentData && <Step2 paymentData={paymentData} connectedAccounts={connectedAccounts} setLoading={setLoading.bind(this)} tenantDet={tenantDet} tenantDet2={tenantDet2} setConnectedAccounts={setConnectedAccounts.bind(this)} isSecondPaymentStep={isSecondPaymentStep} />}
                    </div>
                </div>

                <div className={`${styles.FooterWrap}`}>
                    <div className={`${styles.footerMain}`}>

                        <div className={`${styles.footerMainLeft}`}>
                            {(tenantDet?.theme_options?.image_url !== '') && <Linkto to={'/'}><img src={tenantDet?.theme_options?.image_url} alt="logo" /></Linkto>}
                            {(tenantDet?.theme_options?.image_url === '') && <Linkto to={'/'}><img src={'/static/img/logo.svg'} alt="logo" /></Linkto>}
                        </div>

                        <div className={`${styles.footerMainRight}`}>
                            <div>
                                <h3>CONTACT US</h3>
                                <ul>
                                    <li><a href={"mailto:" + propertyDet?.email}>{propertyDet?.email}</a></li>
                                    <li><a href={"mailto:" + propertyDet?.phone}>{propertyDet?.phone}</a></li>
                                </ul>
                            </div>
                            <div>
                                <h3>FIND US</h3>
                                <ul>
                                    <li>{propertyDet?.address} <br />{propertyDet?.city}, {propertyDet?.state} {propertyDet?.zip}</li>
                                </ul>
                            </div>
                            <div>
                                <h3>LEGAL</h3>
                                <ul>
                                    <li><Linkto to={'/privacy-policy'}>Privacy Policy</Linkto></li>
                                    <li><Linkto to={'/eula'}>End User License Agreement</Linkto></li>
                                </ul>
                            </div>
                            <div>
                                <ul>
                                    <li>PropertyDek © {dayjs().format("YYYY")}.<br />All rights reserved.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>}

        <SmartToaster
            store={toast}
            lightBackground={true}
            position={"top_center"}
        />
    </>);
}

export default AppPay;
